// Invoice Management Frontend Configuration

export const config = {
    // Portal API (Auth)
    PORTAL_API_URL: process.env.REACT_APP_PORTAL_API_URL || 'http://localhost:5002',

    // Invoice Management API
    API_URL: process.env.REACT_APP_API_URL || 'http://localhost:5004',

    // Portal Frontend (for redirects)
    PORTAL_URL: process.env.REACT_APP_PORTAL_URL || 'http://localhost:3001',
};

export const API_ENDPOINTS = {
    // Auth endpoints (point to Portal)
    AUTH_ME: `${config.PORTAL_API_URL}/api/auth/me`,
    USERS: `${config.PORTAL_API_URL}/api/users`,
    VALIDATE_TOKEN: `${config.PORTAL_API_URL}/api/auth/validate-token`,

    // Local API for user verification
    ME: `${config.API_URL}/api/me`,

    // Invoice endpoints
    INVOICES: `${config.API_URL}/api/invoices`,
    INVOICE_DETAIL: (id: string) => `${config.API_URL}/api/invoices/${id}`,
};

export default config;
